import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-statistics-chart-card',
    templateUrl: './statistics-chart-card.component.html',
    styleUrls: ['./statistics-chart-card.component.scss']
})
export class StatisticsChartCardComponent implements OnInit {
    @Input() title: string = '';
    @Input() chartType: 'bar' | 'line' | 'pie' | 'doughnut' | 'radar' | 'polarArea' = 'bar';
    @Input() chartData: any;
    @Input() chartOptions: any;
    @Input() height: string = '300px';
    @Input() loading: boolean = false;
    @Input() emptyMessage?: string;

    constructor() { }

    ngOnInit(): void {
    }

    get hasData(): boolean {
        if (!this.chartData) return false;
        if (!this.chartData.datasets) return false;
        if (this.chartData.datasets.length === 0) return false;

        // Check if at least one dataset has data
        return this.chartData.datasets.some((dataset: any) =>
            dataset.data && dataset.data.length > 0
        );
    }
}
